export var fullSizeAbsoluteStyle = "\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n";